import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { CardV2 as Card } from '@feathr/components';
import { Goal } from '@feathr/extender/components';
import { useStore } from '@feathr/extender/state';

function GoalsTwoPointOh(): JSX.Element {
  const { Goals } = useStore();
  const goal = Goals.create({ name: 'New test goal' });

  return (
    <Card width={'wide'}>
      <Card.Header title={'Goals 2.0'} />
      <Card.Content>
        <Goal goal={goal} />
      </Card.Content>
    </Card>
  );
}

export default observer(GoalsTwoPointOh);
